import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import {
    REPORT_USAGE,
    VISIBLE,
} from 'src/constants/appConstants';
import {
    VALIDATE_PRODUCT_DETAILS_FAILURE,
    STORE_UNID_SURGERY_INFO,
} from 'src/pages/reportUsage/redux/action/types';

/**
 * Custom hook to handle report payment effect logic.
 * @param {Object} params - All dependencies and setters required for the effect.
 */
export function useReportPaymentEffectt({
    validProducts,
    reportPaymentGridData,
    showReportPayment,
    reportUsageFormObj,
    getRPValidatedItemTableData,
    countryCode,
    setReportPaymentGridData,
    checkIfValidReportPaymentData,
    getProductsArrFromReportPaymentFlow,
    myCaseResourceType,
    setFooterButtonStatuses,
    footerButtonStatuses,
    next,
    createReportPaymentSubmissionProductsArr,
    submit,
    setReportUsageFormObj,
    dispatch,
    setReportPaymentScreenName,
    getModifiedButtonVisibilities,
    reportPaymentButtonVisibility,
    procedurePageVisibility,
    replenish,
    review,
    modifyDraftProductsResponse,
    usageDetails,
    setFilteredProduct,
    progressBarClicked,
    reportPaymentFlag,
    currentActivity,
    setCurrentActivity,
    REPORTPROGRESSTEPS,
    setShowReportPayment,
    updateStoredUnidInfoSurgeryData,
    storedUnidSurgeryData,
    setReportPaymentFlag,
    setProgressBarStatus,
    procedure,
    replenishmentPageVisibilityUsage
}) {
    useEffectWithErrorLogging(() => {
        if (
            validProducts &&
            validProducts.length > 0 &&
            reportPaymentGridData.length > 0 &&
            showReportPayment
        ) {
            const accountOwnedItems =
                reportUsageFormObj.products?.length > 0
                    ? reportUsageFormObj.products

                        .map((item, index) => {
                            if (item.isAccountOwned || item.accountOwned) {
                                return {
                                    ...item,
                                    recordIndex: index,
                                };
                            } else {
                                return item;
                            }
                        })
                        .filter(
                            (filterItem) =>
                                filterItem.isAccountOwned ||
                                filterItem.accountOwned
                        )
                    : [];
            const validatedItemTableData = getRPValidatedItemTableData(
                reportPaymentGridData,
                validProducts,
                countryCode
            );
            setReportPaymentGridData(validatedItemTableData);
            if (
                checkIfValidReportPaymentData(
                    validProducts,
                    validatedItemTableData
                )
            ) {
                let updatedItem = [...validatedItemTableData];
                accountOwnedItems.map((ownedItem) => {
                    let temp = {
                        ...ownedItem,
                    };
                    delete temp.recordIndex;
                    updatedItem.splice(ownedItem.recordIndex, 0, temp);
                });
                const productsArr =
                    getProductsArrFromReportPaymentFlow(updatedItem);
                if (myCaseResourceType === 'reportPayment') {
                    setFooterButtonStatuses(
                        footerButtonStatuses.map((x) =>
                            x.btnName === next
                                ? { ...x, isBtnDisable: false }
                                : x
                        )
                    );
                    const reportPaymentProductsArr =
                        createReportPaymentSubmissionProductsArr(
                            updatedItem,
                            reportUsageFormObj.products?.length > 0
                                ? reportUsageFormObj?.products
                                : [],
                            myCaseResourceType
                        );
                    const reportPaymentRequestObj = {
                        ...reportUsageFormObj,
                        isSapSubmission: true,
                        products: reportPaymentProductsArr,
                        isPriceUpdated: reportPaymentGridData.some(
                            (item) => item.isPriceUpdated
                        ),
                    };


                    setReportUsageFormObj(reportPaymentRequestObj);
                    // submitUsageOrder(reportPaymentRequestObj);
                    const moveToReplenishScreen =
                        validatedItemTableData &&
                        validatedItemTableData.length > 0 &&
                        validatedItemTableData.some(
                            (item) =>
                                item?.isAdditionalCartEntry &&
                                item?.isReplenishmentRequired &&
                                item.salesOrg !== 'S030' &&
                                !item?.cfn?.startsWith('B33') &&
                                item.materialType !== 'DIEN' &&
                                (item?.isBundleItem
                                    ? item?.bundleItem &&
                                    item?.bundleItem.length > 0 &&
                                    !item?.bundleItem.every((child) =>
                                        child?.cfn?.startsWith('B33')
                                    )
                                    : true)
                        );
                    if (moveToReplenishScreen && replenishmentPageVisibilityUsage) {
                        dispatch(setReportPaymentScreenName('Replenish'));

                    } else {
                        dispatch(setReportPaymentScreenName('Review'));
                        const modifiedButtonStatuses =
                            getModifiedButtonVisibilities(
                                myCaseResourceType,
                                footerButtonStatuses,
                                next,
                                submit
                            );
                        setFooterButtonStatuses(modifiedButtonStatuses);
                    }



                } else {
                    const draftProducts = modifyDraftProductsResponse(
                        productsArr,
                        usageDetails.bundleHeaders
                            ? usageDetails.bundleHeaders.split(',')
                            : [],
                        usageDetails.unidSurgeryInfoPage?.deliveredRodItems,
                        true
                    );
                    setFilteredProduct(draftProducts);
                    if (!progressBarClicked && !reportPaymentFlag) {
                        const prevCurrentActivity = currentActivity;
                        dispatch(setProgressBarStatus(currentActivity));
                        setCurrentActivity(
                            REPORTPROGRESSTEPS[
                            REPORTPROGRESSTEPS.findIndex(
                                (activity) => activity === currentActivity
                            ) + 1
                            ]
                        );
                        const modifiedButtonStatuses =
                            getModifiedButtonVisibilities(
                                myCaseResourceType,
                                footerButtonStatuses,
                                reportPaymentButtonVisibility === VISIBLE &&
                                    !procedurePageVisibility
                                    ? replenishmentPageVisibilityUsage ? replenish : procedurePageVisibility ? procedure : review
                                    : prevCurrentActivity === 'Record' ? replenish : review,
                                reportPaymentButtonVisibility === VISIBLE &&
                                    prevCurrentActivity !== 'Procedure'
                                    ? !procedurePageVisibility
                                        ? review
                                        : procedure
                                    : submit
                            );
                        setFooterButtonStatuses(modifiedButtonStatuses);
                        setShowReportPayment(false);
                        setReportPaymentGridData([]);
                        updateStoredUnidInfoSurgeryData(
                            storedUnidSurgeryData,
                            draftProducts
                        );
                    }
                    setReportPaymentFlag(false);
                }
            } else {
                dispatch({
                    type: VALIDATE_PRODUCT_DETAILS_FAILURE,
                    payload: { validItems: [], productsValidated: true },
                });
                const modifiedButtonStatuses = footerButtonStatuses.map((x) =>
                    x.btnName === review && x.btnVisibility
                        ? { ...x, isBtnDisable: true }
                        : x
                );
                setFooterButtonStatuses(modifiedButtonStatuses);
            }
        }
    }, [validProducts]);
}
